import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import React from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import { CircularProgress } from "@mui/material";
import { onlineManager } from "@tanstack/react-query";

import useDebounce from "../../lib/useDebounce";

export default function RefreshWithProgress() {
  const isOnline = onlineManager.isOnline();
  const queryClient = useQueryClient();
  const isFetching = useIsFetching();
  const debouncedIsFetching = useDebounce(isFetching, 25);
  if (!isOnline) return <CloudOffIcon />;
  else if (!debouncedIsFetching) {
    return (
      <RefreshIcon
        onClick={() => {
          queryClient.invalidateQueries({
            predicate: (query) => {
              if (query.queryKey[0] === "observationStations") return false;
              return query.state.error?.response.status !== 404;
            },
          });
        }}
      />
    );
  } else
    return (
      <CircularProgress
        color="inherit"
        size={24}
        onClick={() => {
          queryClient.cancelQueries();
        }}
      />
    );
}
